var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("仓位管理")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "仓区"
                                    },
                                    model: {
                                      value: _vm.form.area,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "area", $$v)
                                      },
                                      expression: "form.area"
                                    }
                                  },
                                  _vm._l(_vm.areasOptions, function(item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "架" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.shelf,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shelf", $$v)
                                    },
                                    expression: "form.shelf"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "层" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.floor,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "floor", $$v)
                                    },
                                    expression: "form.floor"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "位" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.position,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "position", $$v)
                                    },
                                    expression: "form.position"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "sku" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.sku,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "sku", $$v)
                                    },
                                    expression: "form.sku"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "是否多sku仓位"
                                    },
                                    model: {
                                      value: _vm.form.is_more_sku,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_more_sku", $$v)
                                      },
                                      expression: "form.is_more_sku"
                                    }
                                  },
                                  _vm._l(_vm.sku_status, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.value,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "仓位是否多sku"
                                    },
                                    model: {
                                      value: _vm.form.is_band_many_sku,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "is_band_many_sku",
                                          $$v
                                        )
                                      },
                                      expression: "form.is_band_many_sku"
                                    }
                                  },
                                  _vm._l(_vm.band_sku_status, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.value,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "dbid" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.dbid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "dbid", $$v)
                                    },
                                    expression: "form.dbid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "状态"
                                    },
                                    model: {
                                      value: _vm.form.is_use,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_use", $$v)
                                      },
                                      expression: "form.is_use"
                                    }
                                  },
                                  _vm._l(_vm.status_list, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.value,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "仓位是否已绑定商品"
                                    },
                                    model: {
                                      value: _vm.form.is_band,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "is_band", $$v)
                                      },
                                      expression: "form.is_band"
                                    }
                                  },
                                  _vm._l(_vm.band_status, function(item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.value,
                                        value: item.key
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "品类"
                                    },
                                    model: {
                                      value: _vm.form.cate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "cate", $$v)
                                      },
                                      expression: "form.cate"
                                    }
                                  },
                                  [
                                    _c("el-option", { attrs: { value: "" } }, [
                                      _vm._v("全部")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.categoryOptions, function(item) {
                                      return _c("el-option", {
                                        key: item.cat_id,
                                        attrs: {
                                          label: item.cat_name,
                                          value: item.cat_id
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "用户id" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.user_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "user_id", $$v)
                                    },
                                    expression: "form.user_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "波次号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.wave_picking_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wave_picking_no", $$v)
                                    },
                                    expression: "form.wave_picking_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      filterable: "",
                                      placeholder: "仓位属性"
                                    },
                                    model: {
                                      value: _vm.form.space_type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "space_type", $$v)
                                      },
                                      expression: "form.space_type"
                                    }
                                  },
                                  [
                                    _c("el-option", { attrs: { value: "" } }, [
                                      _vm._v("全部")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.locationAttributeStatus,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.value,
                                            value: item.key
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.clearSelectedStockSpaces }
                    },
                    [_vm._v("\n          批量清空仓位\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.bandLog } },
                    [_vm._v(" 操作日志 ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.batchEdit } },
                    [_vm._v("批量操作")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { background: "#85ce61" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.addSpaceVisible = true
                        }
                      }
                    },
                    [_vm._v("\n          新增仓位\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setStatusOfMany(0)
                        }
                      }
                    },
                    [_vm._v("\n          批量禁用\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.setStatusOfMany(1)
                        }
                      }
                    },
                    [_vm._v("\n          批量启用\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.exportExcel }
                    },
                    [_vm._v("\n          导出\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "第一行表头，A列仓位，B列仓位属性，C列是否多SKU仓位（Y:是，N:否）",
                        placement: "top-start"
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "20px"
                          },
                          attrs: {
                            action: _vm.action,
                            name: "file",
                            data: { action: 1 },
                            "on-success": _vm.importSuccess,
                            "on-error": _vm.importError,
                            "show-file-list": false,
                            "with-credentials": ""
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "mini", type: "primary" } },
                            [_vm._v("导入添加仓位")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content:
                          "第一行表头，A列仓位，B列启用 (Y） / 禁用(N），C列商品品类，D列仓位囤货量，E列仓位SKU上限量， CDE列可不填写，若为空则默认为不限制。",
                        placement: "top-start"
                      }
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          staticStyle: {
                            display: "inline-block",
                            "margin-left": "20px"
                          },
                          attrs: {
                            action: _vm.updateSpaceAction,
                            name: "file",
                            "on-success": _vm.importSuccess,
                            "on-error": _vm.importError,
                            "show-file-list": false,
                            "with-credentials": ""
                          }
                        },
                        [
                          _c(
                            "el-button",
                            { attrs: { size: "mini", type: "primary" } },
                            [_vm._v("导入修改仓位状态")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _vm.resData
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "800",
                            data: _vm.resData.list,
                            "tooltip-effect": "dark",
                            "cell-class-name": _vm.addColor
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              type: "selection",
                              width: "55"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "仓位",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.openBarCode(
                                                scope.row.area +
                                                  scope.row.shelf +
                                                  "-" +
                                                  scope.row.floor +
                                                  "-" +
                                                  scope.row.position
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.area) +
                                              _vm._s(scope.row.shelf) +
                                              "-" +
                                              _vm._s(scope.row.floor) +
                                              "-" +
                                              _vm._s(scope.row.position) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3165494676
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "sku",
                              label: "sku编号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "sku_num",
                              label: "仓位sku数量"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "num",
                              label: "商品总数"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "box_no",
                              label: "容器号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "dbids",
                              label: "商品明细",
                              "show-overflow-tooltip": "",
                              width: "300"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "user_id",
                              label: "用户 id"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "wave_picking_no",
                              label: "波次号"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "shipping_space_is_more_sku",
                              label: "是否多sku仓位",
                              "show-overflow-tooltip": "",
                              width: "300"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "space_type_str",
                              label: "仓位属性"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "update_time",
                              label: "仓位绑定时间"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "shipping_space_is_use",
                              label: "状态"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "cat_names",
                              label: "品类"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "囤货量/件",
                              prop: "max"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "200",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.beforeBand(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                编辑\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type:
                                              scope.row.is_use == 1
                                                ? "success"
                                                : "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setStatus(scope.row)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.is_use == 1
                                                ? "已启用"
                                                : "已禁用"
                                            ) + "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3508438530
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "编辑",
                    visible: _vm.bandVisible,
                    width: "20%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.bandVisible = $event
                    },
                    closed: _vm.handleDialogClosed
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form, "label-width": "120px" } },
                    [
                      _c("el-form-item", { attrs: { label: "仓位" } }, [
                        _c("span", [_vm._v(_vm._s(_vm.space))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: "商品品类",
                                disabled:
                                  _vm.form.space_type ===
                                  _vm.STORAGE_TYPE.STORAGE
                              },
                              model: {
                                value: _vm.form.band_cate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "band_cate", $$v)
                                },
                                expression: "form.band_cate"
                              }
                            },
                            _vm._l(_vm.categoryOptions, function(item) {
                              return _c("el-option", {
                                key: item.cat_id,
                                attrs: {
                                  label: item.cat_name,
                                  value: item.cat_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓位囤货量" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "190px" },
                            attrs: {
                              placeholder: "仓位囤货量",
                              type: "number",
                              controls: false,
                              min: "0",
                              disabled:
                                _vm.form.space_type ===
                                _vm.STORAGE_TYPE.STORAGE,
                              "on-keypress":
                                "return (/[\\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                            },
                            model: {
                              value: _vm.form.band_max,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "band_max", _vm._n($$v))
                              },
                              expression: "form.band_max"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否多sku仓位" } },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              "true-label": "1",
                              "false-label": "0",
                              disabled:
                                _vm.form.space_type === _vm.STORAGE_TYPE.STORAGE
                            },
                            on: { change: _vm.onCheckboxChange },
                            model: {
                              value: _vm.form.edit_is_more_sku,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "edit_is_more_sku", $$v)
                              },
                              expression: "form.edit_is_more_sku"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: {
                              width: "120px",
                              "margin-left": "16px"
                            },
                            attrs: {
                              placeholder: "SKU数量上限",
                              type: "number",
                              controls: false,
                              disabled: _vm.form.edit_is_more_sku === "0",
                              min: "0"
                            },
                            nativeOn: {
                              keydown: function($event) {
                                return _vm.validateSKUInput.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.max_sku_num,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "max_sku_num", _vm._n($$v))
                              },
                              expression: "form.max_sku_num"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓位属性" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "仓位属性",
                                disabled: _vm.hasGoods
                              },
                              model: {
                                value: _vm.form.space_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "space_type", $$v)
                                },
                                expression: "form.space_type"
                              }
                            },
                            _vm._l(_vm.locationAttributeStatus, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.bandVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.batchEditSave }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "编辑",
                    visible: _vm.batchEditDialogVisible,
                    width: "30%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.batchEditDialogVisible = $event
                    },
                    closed: _vm.handleDialogClosed
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓位属性" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "仓位属性",
                                disabled: _vm.hasGoods
                              },
                              model: {
                                value: _vm.form.space_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "space_type", $$v)
                                },
                                expression: "form.space_type"
                              }
                            },
                            _vm._l(_vm.locationAttributeStatus, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: "商品品类",
                                disabled:
                                  _vm.form.space_type ===
                                  _vm.STORAGE_TYPE.STORAGE
                              },
                              model: {
                                value: _vm.form.band_cate,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "band_cate", $$v)
                                },
                                expression: "form.band_cate"
                              }
                            },
                            _vm._l(_vm.categoryOptions, function(item) {
                              return _c("el-option", {
                                key: item.cat_id,
                                attrs: {
                                  label: item.cat_name,
                                  value: item.cat_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓位囤货量" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "190px" },
                            attrs: {
                              placeholder: "仓位囤货量",
                              type: "number",
                              controls: false,
                              min: "0",
                              disabled:
                                _vm.form.space_type ===
                                _vm.STORAGE_TYPE.STORAGE,
                              "on-keypress":
                                "return (/[\\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8"
                            },
                            model: {
                              value: _vm.form.band_max,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "band_max", _vm._n($$v))
                              },
                              expression: "form.band_max"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否多sku仓位" } },
                        [
                          _c("el-checkbox", {
                            attrs: {
                              "true-label": "1",
                              "false-label": "0",
                              disabled:
                                _vm.form.space_type === _vm.STORAGE_TYPE.STORAGE
                            },
                            on: { change: _vm.onCheckboxChange },
                            model: {
                              value: _vm.form.edit_is_more_sku,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "edit_is_more_sku", $$v)
                              },
                              expression: "form.edit_is_more_sku"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: {
                              width: "120px",
                              "margin-left": "16px"
                            },
                            attrs: {
                              placeholder: "SKU数量上限",
                              type: "number",
                              controls: false,
                              disabled: _vm.form.edit_is_more_sku === "0",
                              min: "0"
                            },
                            nativeOn: {
                              keydown: function($event) {
                                return _vm.validateSKUInput.apply(
                                  null,
                                  arguments
                                )
                              }
                            },
                            model: {
                              value: _vm.form.max_sku_num,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "max_sku_num", _vm._n($$v))
                              },
                              expression: "form.max_sku_num"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.batchEditDialogVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.batchEditSave }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "添加仓位",
                    visible: _vm.addSpaceVisible,
                    width: "30%",
                    center: "",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.addSpaceVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.addForm,
                        "label-position": "right",
                        "label-width": "70px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓区：", prop: "is_strength" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "70%", float: "left" },
                              attrs: { placeholder: "仓区" },
                              model: {
                                value: _vm.addForm.area,
                                callback: function($$v) {
                                  _vm.$set(_vm.addForm, "area", $$v)
                                },
                                expression: "addForm.area"
                              }
                            },
                            _vm._l(_vm.areasOptions, function(item) {
                              return _c("el-option", {
                                key: item,
                                attrs: { label: item, value: item }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "通道：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            attrs: { placeholder: "1~999" },
                            model: {
                              value: _vm.addForm.shelf,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "shelf", $$v)
                              },
                              expression: "addForm.shelf"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "货架组：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            attrs: { placeholder: "1~99" },
                            model: {
                              value: _vm.addForm.floor,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "floor", $$v)
                              },
                              expression: "addForm.floor"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "列：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            attrs: { placeholder: "1~9" },
                            model: {
                              value: _vm.addForm.col,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "col", $$v)
                              },
                              expression: "addForm.col"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "层：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            attrs: { placeholder: "1~9" },
                            model: {
                              value: _vm.addForm.row,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "row", $$v)
                              },
                              expression: "addForm.row"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "仓位属性" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "仓位属性",
                                disabled: _vm.hasGoods
                              },
                              model: {
                                value: _vm.addForm.space_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.addForm, "space_type", $$v)
                                },
                                expression: "addForm.space_type"
                              }
                            },
                            _vm._l(_vm.locationAttributeStatus, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.addSpaceVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addSpace }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: { title: "操作日志", visible: _vm.logVisible },
                  on: {
                    "update:visible": function($event) {
                      _vm.logVisible = $event
                    }
                  }
                },
                [
                  _vm.logInfo
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "300",
                            data: _vm.logInfo.list,
                            "tooltip-effect": "dark"
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "operator_name", label: "操作人" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.operator_name == 0
                                              ? ""
                                              : scope.row.operator_name
                                          )
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2776680179
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "action_ext",
                              label: "仓位"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "action_content",
                              label: "操作内容"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "create_date",
                              label: "操作时间"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.logcurPage,
                      background: "",
                      layout: "total, prev, pager, next, jumper ",
                      total: _vm.logInfo.page,
                      "page-size": 20
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.logcurPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.logcurPage = $event
                      },
                      "current-change": _vm.handleCurrentChange2
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", padding: "25px" } },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.curPage,
                          background: "",
                          layout: "total, prev, pager, next, jumper ,sizes",
                          total: _vm.resData.count,
                          "page-size": _vm.form.pagesize,
                          "page-sizes": [50, 100, 200, 500, 1000]
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.curPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.curPage = $event
                          },
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12f76287", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f76287","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/space/SpaceList.vue
// module id = null
// module chunks = 